import { BaseInterface } from './base.interface';

export type ProviderCategoryType = 'SportsBook' | 'Esports' | 'Lottery' | 'LiveCasino' | 'SlotGame' | 'Chess';

/**
 * 游戏币种和比例
 */
export interface CurrencyRatio extends BaseInterface {
  /**币种 */
  currency: string;
  /**比例 */
  ratio: number;
}

/**
 * 获取厂商列表 返回数据
 */
export interface ProviderInterface {
  providerCatId: string;
  providerId: string;
  providerName: string;
  dayLogo: string;
  nightLogo: string;
  status: string;
  gameCount: number;
  /**SportsBook:体育Esports:电子竞技Lottery:彩票LiveCasino:真人娱乐场SlotGame:老虎机Chess:棋牌 */
  category: string;
  currencyRatio: CurrencyRatio[];
  /**true 进入 二级页，false进入三级页（直接玩） */
  secondaryPage: boolean;
  /**是否为转账制 */
  isTransfer: boolean;
  /**排序 */
  sort: number;
  /**厂商支持国家编码，为空数组，就是不限制国家 */
  countryCode: string[];
  /**游戏打开方式 */
  gameOpenMethod: { [key: string]: 'Iframe' | 'NewWindow' };
  /** 是否支持试玩 */
  isTry?: boolean;
  /** 是否在 大厅页展示 iframe */
  showHome: boolean;
  currencies: string[];
}

/**
 * 根据厂商获取标签列表 返回数据
 */
export interface LabelCodeList extends BaseInterface {
  /**标签id */
  code: string;
  /**标签名字 */
  name: string;
  /**标签图标 */
  icon: string;
  /**游戏数量 */
  gameCount?: number;
}

/**
 * 获取游戏列表 返回数据
 */
export interface GameList extends BaseInterface {
  /**标签代号 */
  labelCode: string;
  /**标签名称 */
  labelName: string;
  /**标签描述 */
  description: string;
  /**标签icon */
  icon: string;
  /**标签所属游戏总数 */
  gameCount: number;
  /**游戏列表 */
  gameLists: GameListItem[];
}

/**
 * 游戏搜索
 */
export interface GameSearch {
  labelInfo: {
    labelId: string;
    labelName: string;
  }[];
  gameInfo: GameListItem[];
}

/** 新游戏列表 */
export interface NewGameList extends BaseInterface {
  /**标签名称 */
  labelName: string;
  /**标签icon */
  icon: string;
  /**游戏列表 */
  gameLists: GameListItem[] | [];
}

/**
 * 游戏列表成员
 */
export interface GameListItem {
  /**id */
  id: number;
  /**厂商id */
  providerCatId: string;
  /**厂商id */
  // providerId: string;
  /**厂商名称 */
  providerName: string;
  /**游戏id */
  gameId: string;
  /**名称 */
  gameName: string;
  /**简介 */
  gameDesc: string;
  /**weblogo */
  webLogo: string;
  /**h5Logo */
  h5Logo: string;
  /**appLogo */
  appLogo: string;
  /**状态 */
  status: 'Maintenance' | 'Online' | 'Offline';
  /**是否可以试玩 */
  isTry: boolean;
  /**是否全屏打开 */
  isFullScreen: boolean;
  /**是否收藏 */
  isFavorite: boolean;
  /**庄家优势 */
  bankerAdvantage: number | null;
  /**RTP */
  returnToPlayer: number | null;
  /**标签 */
  gameLabels: {
    code: string;
    description: string;
  }[];
  /**币种&比率 */
  currencyRatio: CurrencyRatio[];
  /**厂商支持国家编码，为空，就是不限制国家 */
  countryCode: string[];
  /**指定跳转连接 */
  webRedirectUrl: string;
  /**投注级距配置 */
  betRangeSetting: ProviderSetting;
  category: string;
  providerId: string;
}

/**
 * 获取游戏类型下拉 返回数据
 */
export interface ProviderCategoryInterface extends BaseInterface {
  code: string;
  description: string;
}

/**
 * 获取游戏列表-游戏供应商分类
 */
export interface GameProviderParams {
  labelCode?: string[];
  providerCatIds: string[] | null;
  gameTypes?: string[];
  sort: string;
  pageIndex: number;
  pageSize: number;
  /**
   * 排序类型
   *  HomeSort:0, //首页排序 首页排序，或者不传sortType 默认就是这个
   *  ProviderSort:1, //厂商排序 点击厂商的时候传递
   *  LabelSort:2, //标签排序 点击标签的时候传递
   */
  sortType?: SortType;
}

export type SortType = 'HomeSort' | 'ProviderSort' | 'LabelSort';

/**
 * 取得游戏链接请求参数
 */
export interface PlayGameParams {
  /** 游戏商代码 */
  providerCatId: string;
  /** 游戏代码 */
  gameId: string;
  /** 用户币别代码 */
  currencyCode: string;
  /** 游戏币别代码 */
  gameCurrencyCode: string;
  /** 试玩模式 */
  playMode: 'Normal' | 'Try';
  /** 网站类型 */
  siteType: 'PC' | 'Mobile' | 'App';
  /** 盘口类型 */
  oddsType?: string;
  /** 请求方域名 */
  domain?: string;
  /** AG盤口類型 */
  agOddType?: string;
  /** 日夜间模式 */
  showMode: 'Day' | 'Night';
}

/**
 * 取得游戏链接结果返回
 */
export interface PlayGameResponse {
  playGameUrl: string;
  token?: string;
}

/**
 * swiper组建数据
 */
export interface GameListData extends BaseInterface {
  key: GameSwiperListData;
}

/**
 * swiper组建数据
 */
export interface GameSwiperListData extends BaseInterface {
  description: string;
  gameCout: number;
  gameLists: any; //array
  icon: string;
  labelCode: string;
  labelName: string;
}

//获取所有游戏标签返回数据
export interface Gamelabel extends BaseInterface {
  /**随机数字字符串 */
  code: string;
  /**显示名称 */
  name: string;
  /**暂无用 */
  description: string;
  /**普通标签栏标签图标 */
  icon: string;
  /**标签二级页面右上角的背景图 */
  image: string;
  /**左侧菜单小图标 */
  menuIcon: string;
}

//获取游戏排序下拉返回数据
export interface GameSort extends BaseInterface {
  code: string;
  description: string;
  icon: string;
}

//gamelistbylabel请求参数
export interface GameListByLabelParams {
  labelCodes: string[];
  isRecomment?: boolean;
  gameCount?: number;
  /** 是否是 游戏大厅 - 默认为false*/
  isHall?: boolean;
  /** 0: 不区分； 1: 娱乐城； 2: 彩票 - 默认为0*/
  entryType?: number;
  /**厂商id，应该是providerCatId的，但后端还没改，目前也无用到，暂时忽略 */
  providerId?: string;
  // providerCatId?: string;
}

//gamelistbylabel请求参数
export interface GameListByTypeParams extends BaseInterface {
  gameTypes: ('SportsBook' | 'Esports' | 'Lottery' | 'LiveCasino' | 'SlotGame' | 'Chess')[];
  isRecomment?: boolean;
  gameCount?: number;
}

/**
 * 获取游戏收藏列表Params
 */
export interface GameFavoriteListParams extends BaseInterface {
  pageIndex: number;
  pageSize: number;
}
/**
 * 游戏收藏列表
 */
export interface GameFavoriteList extends BaseInterface {
  total: number;
  gameIds: number[];
  gameList: GameListItem[];
}

/**
 * 场景标签
 */
export interface ScenesLabel extends BaseInterface {
  sort: number;
  labelId: string;
  name: string;
  icon: string;
  image: string;
  menuIcon: string;
}

/**
 * 场景标签列表
 */
export interface ScenesLabelList extends BaseInterface {
  type: 'Hall' | 'Menu' | 'HallBar' | 'FrontPage';
  labelList: ScenesLabel[];
}

/**
 * 投注级距配置
 */
// export interface BetRangeSetting extends BaseInterface {
//   providerSettingList: ProviderSetting;
// }

/**
 * 投注级距配置
 */
export interface ProviderSetting {
  providerId: string;
  providerCatId: string;
  currencySettingList: {
    currency: string;
    rangeSettingList: {
      oddType: string;
      value: string;
    }[];
  }[];
}

export interface ScenesInfo extends BaseInterface {
  /**标签id */
  labelCode: string;
  /**标签名字 */
  labelName: string;
  /**描述 */
  description: string;
  /**标签栏图标 */
  icon: string;
  /**标签页装饰图 */
  image: string;
  /**左侧菜单icon */
  menuIcon: string;
  /**标签所属游戏总数 */
  gameCount: number;
  /**游戏列表 */
  gameLists: GameListItem[];
  /**是否是活动推荐 */
  isActivityRecommend: boolean;
  /**web活动推荐图 IsActivityRecommend=true时存在 */
  webRecommendImage: string;
  /**H5活动推荐图 IsActivityRecommend=true时存在 */
  h5RecommendImage: string;
  /**开启促销 */
  openPromotion: boolean;
  /**场景标签跳转方式 */
  redirectMethod: 'LabelPage' | 'AssignUrl';
  /** 指定Url RedirectMethod=AssignUrl时存在 */
  assignUrl: string;
  /** 指定Url RedirectMethod=AssignUrl时存在(APP专用，web忽略) */
  assignAppUrl: string;
  /**多行显示 */
  multiLine: number;
}

/**
 * 厂商详情
 */

export interface ProviderDetail extends BaseInterface {
  id: number;
  /**	厂商ID*/
  providerId: string;
  /**	厂商产品名称*/
  providerName: string;
  /**SportsBook:1, //体育
   *Esports:2, //电子竞技
   *Lottery:3, //彩票
   *LiveCasino:4, //真人娱乐场
   *SlotGame:5, //老虎机
   *Chess:6, //棋牌
   */
  category: string;
  /**游戏清单（多个换行符分割） */
  gameList: string;
  /**游戏供应商logo */
  dayLogo: string;
  /**游戏供应商logo */
  nightLogo: string;
  /**成立年份 */
  foundedYear: 0;
  /**游戏数量 */
  gameCount: 0;
  /**游戏厂商简介 */
  providerDesc: string;
  /**游戏标签 */
  providerLabels: [
    {
      labelId: number;
      description: string;
      gameCount: number;
    },
  ];
}

/** 新标签 */
export interface NewTags extends BaseInterface {
  headerMenus: Array<IHeaderMenus>;
  leftMenus: Array<ILeftMenus>;
  navigationMenus: Array<IHeaderMenus>;
}

/** 左侧菜单 */
export interface ILeftMenus extends BaseInterface {
  key: number;
  labelId: number;
  redirectMethod: 'DropDownList' | 'LabelPage' | 'AssignUrl' | 'AssignProvider' | 'AssignGame';
  name: string;
  icon: string;
  enableFavorites: boolean;
  enableRecentlyPlayed: boolean;
  config: Config | null;
  infoExpandList: Array<InfoExpandList> | null;
  infoHorizontalList: Array<InfoHorizontalList> | null;
  infoVerticallyList: Array<InfoVerticallyList> | null;
}

/** 头部 */
export interface IHeaderMenus extends BaseInterface {
  key: string;
  name: string;
  icon: string;
  menuIcon: string;
  labelId: number;
  redirectMethod: string;
  config: Config | null;
  infoExpandList: Array<InfoExpandList> | null;
  infoHorizontalList: Array<InfoHorizontalList> | null;
  infoVerticallyList: Array<InfoVerticallyList> | null;
}

export interface Config extends BaseInterface {
  assignAppUrl?: string;
  assignGameCode?: string;
  assignGameProviderId?: string;
  assignProviderId?: string;
  assignUrl?: string;
  assignDropDownListUrl?: string;
}

export interface InfoExpandList extends BaseInterface {
  pid: number;
  labelName: string;
  scenesType: 'Expand' | 'Vertically' | 'Horizontal' | string;
  labelId: number;
  config: Config | null;
  multiLine: number;
  redirectMethod: 'DropDownList' | 'LabelPage' | 'AssignUrl' | 'AssignProvider' | 'AssignGame' | string;
  sort: number;
  labelCode: string;
  description: string;
  icon: string;
  image: string;
  menuIcon: string;
  gameCount: number;
  isActivityRecommend: boolean;
  webRecommendImage: string | null;
  h5RecommendImage: string | null;
  openPromotion: boolean;
  providerSetting: {
    secondaryPage: boolean;
    gameOpenMethod: string | null;
  } | null;
}

export interface InfoHorizontalList extends BaseInterface, InfoExpandList {}
export interface InfoVerticallyList extends BaseInterface, InfoExpandList {}

/** 新大厅标签接口 */
export interface GameListByLabelId extends BaseInterface {
  labelId: number;
  gameList: GameListItem[];
}

/** 跳转方式 */
export enum LabelScenesRedirectMethodEnum {
  LabelPage,
  AssignUrl,
  DropDownList,
  AssignProvider,
  AssignGame,
}

/** 新游戏标签 */
export interface NewTagGameList extends BaseInterface, InfoExpandList {
  /**游戏列表 */
  gameLists: GameListItem[];
}
